import React from "react";

function EbayOverview() {
  return <div>Ebay overview text...</div>;
}

export default EbayOverview;
